/**
 * CONTENTS
 * --------
 * FUNCTIONS
 * HELPERS
 * ONLINE PAYMENT FORM SHOW CAR DETAILS BASED ON USER INPUT
 * HOUSE INSURANCE FORM DYNAMIC COUNTY/AREA SELECT OPTIONS
 * HOUSE INSURANCE FORM PREMIUM SELECTION
 * HOUSE INSURANCE FORM PROPERTY TYPE SELECTION
 * HOUSE INSURANCE FORM SPECIFIED RISKS
 * HOUSE INSURANCE FORM BUILDINGS COVER CALCULATOR
 * HOUSE INSURANCE FORM OTHER PROPOSER DETAILS
 * HOUSE INSURANCE FORM TOGGLE POSTAL ADDRESS FIELDS
 * LINKS
 * MOBILE MENU OVERLAY
 * DROPDOWN MENU
 * MODAL
 * TESTIMONIALS CAROUSEL
 * HERO CAROUSEL
 * PARTNER LOGOS CAROUSEL
 * ACCORDION
 * IFRAME WRAPPER
 * TABLE WRAPPER
 * DISCOUNT CODE
 * DATALAYERS
 * Van Insurance Pop up
 * MINIMAL BUILDING COVER AMOUNT SWITCH
 */

window.onload = function () {
	/**
	 * FUNCTIONS
	 */
	function handleAjaxRequest(path, method, callback) {
		var httpRequest = new XMLHttpRequest();

		httpRequest.onreadystatechange = function() {
			if (httpRequest.readyState === 4) {
				if (httpRequest.status === 200 || httpRequest.status === 400) {
					var data = JSON.parse(httpRequest.responseText);

					if (callback) {
						callback(data)
					}
				}
			}
		};

		httpRequest.open(method, path);
		httpRequest.send();
	}

	// add commas to numbers in thousands range
	function CommaFormatted(num) {
		if (num === null) {
			return num;
		}

		var str = num.toString().split('.');

		if (str[0].length >= 4) {
			//add comma every 3 digits befor decimal
			str[0] = str[0].replace(/(\d)(?=(\d{3})+$)/g, '$1,');
		}

		return str.join('.');
	}

	function dataLayer(eventAction, eventLabel, eventValue, businessLine, age, quoteId){
		window.dataLayer = window.dataLayer || [];
		window.dataLayer.push({
			'event': 'DL - Event',
			'eventCategory': 'Funnel',
			'eventAction': eventAction,
			'eventLabel': eventLabel,
			'eventValue': eventValue,
			'questionSetVersion': 'v3',
			'businessLine': businessLine,
			'age': age,
			'quoteid': quoteId,
		});
	}

	function getAgeFromDOB(dob) {
		var today = new Date();
		var birthDate = new Date(dob);
		var age = today.getFullYear() - birthDate.getFullYear();
		var m = today.getMonth() - birthDate.getMonth();
		if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
			age--;
		}
		return age;
	}

	/**
	 * HELPERS
	 */

	var show = function (element, display) {
		if (element !== null && typeof element !== 'undefined') {
			element.style.display = typeof display !== 'undefined' ? display : 'block';
		}
	};

	var hide = function (element) {
		if (element !== null && typeof element !== 'undefined') {
			element.style.display = 'none';
		}
	};

	/**
	 * ONLINE PAYMENT FORM SHOW CAR DETAILS BASED ON USER INPUT
	 */

	var getPolicyType = document.getElementById('policy_details_step_policyType');

	if (getPolicyType) {
		loadCarDetailsInputs();

		getPolicyType.querySelectorAll('input[type="radio"]').forEach(function (radioButton) {
			radioButton.addEventListener('change', loadCarDetailsInputs);
		});
	}

	function loadCarDetailsInputs() {

		var policyType = '';
		var validatePolicyType = document.querySelector('input[name="policy_details_step[policyType]"]:checked');

		if (typeof(validatePolicyType) !== 'undefined' && validatePolicyType !== null) {
			policyType = validatePolicyType.value;
		}

		if(policyType){
			var carDetails = document.getElementById('policy-details-step-car-details');

			if (policyType === 'car_insurance' || policyType === 'van_insurance' ) {
				show(carDetails);
			} else {
				hide(carDetails);
			}
		}
	}

	/**
	 * HOUSE INSURANCE FORM DYNAMIC COUNTY/AREA SELECT OPTIONS
	 */
	var houseInsuranceAreaSelect = document.querySelectorAll(
		'#house_details_step_area, #customer_details_step_postalAddressArea, #policy_details_step_postalAddressArea, #billing_details_step_area'
	)[0];

	var houseInsuranceCountySelect = document.querySelectorAll(
		'#house_details_step_county, #customer_details_step_postalAddressCounty, #policy_details_step_postalAddressCounty, #billing_details_step_county'
	)[0];

	if (houseInsuranceCountySelect) {
		houseInsuranceCountySelect.addEventListener('input', loadCountyAreaChoices);
	}

	function loadCountyAreaChoices() {
		if (this.selectedIndex === 0) {
			houseInsuranceAreaSelect.setAttribute('disabled', 'disabled');
		} else {
			houseInsuranceAreaSelect.removeAttribute('disabled');
		}

		handleAjaxRequest(this.dataset.countyAreasUrl + '?countyCode=' + this.value, 'GET', function (data) {
			var countyAreas = data.result;

			houseInsuranceAreaSelect.options.length = 0;
			houseInsuranceAreaSelect.options[houseInsuranceAreaSelect.options.length] = new Option('Please choose an area');

			for (index in countyAreas) {
				var countyArea = countyAreas[index];
				houseInsuranceAreaSelect.options[houseInsuranceAreaSelect.options.length] = new Option(countyArea, countyArea);
			}
		});
	}

	/**
	 * HOUSE INSURANCE FORM PREMIUM SELECTION
	 */

	var getCoverButtons = document.querySelectorAll('.js-get-cover-button');
	var selectedPremiumField = document.querySelector('#quote_step_isPremiumInclAccidentalDamage');

	if (getCoverButtons.length > 0 && selectedPremiumField) {
		getCoverButtons.forEach(
			function (button) {
				button.addEventListener('click', selectPremium)
			}
		)
	}

	function selectPremium(event) {
		event.preventDefault();
		selectedPremiumField.value = this.value;

		if (selectedPremiumField.value === '0') {
			sessionStorage.setItem('selectedPremium', 'Without Accidental Cover');
			sessionStorage.setItem('eventValue', document.getElementById('premium-exc-accidental-damage').innerText);
		} else {
			sessionStorage.setItem('selectedPremium', 'With Accidental Cover');
			sessionStorage.setItem('eventValue', document.getElementById('premium-inc-accidental-damage').innerText);
		}

		selectedPremiumField.parentNode.submit();
	}

	/**
	 * HOUSE INSURANCE FORM PROPERTY TYPE SELECTION
	 */

	var propertyTypeField = document.querySelector('#house_details_step_propertyType');

	if (propertyTypeField) {
		propertyTypeField.querySelectorAll('input[type="radio"]').forEach(function (radioButton) {
			radioButton.addEventListener('change', toggleBuildingCoverField);
		});
	}

	function toggleBuildingCoverField(){
		var buildingCoverFieldWrapper = document.querySelector('#js-building-cover-field-wrapper');

		if (buildingCoverFieldWrapper && this.value === 'Apartment') {
			hide(buildingCoverFieldWrapper);
			buildingCoverFieldWrapper.querySelector('select').value = 0;

			return;
		}

		show(buildingCoverFieldWrapper);
		buildingCoverFieldWrapper.querySelector('select').value = '';
	}

	/**
	 * HOUSE INSURANCE FORM SPECIFIED RISKS
	 */
	var MAX_SPECIFIED_RISK_ITEMS = 10;
	var specifiedRiskItemsWrapper = document.querySelector('#js-specified-risk-items-wrapper');
	var addSpecifiedRiskItemButton = document.querySelector('#js-add-specified-risk-item-button');

	if (specifiedRiskItemsWrapper && addSpecifiedRiskItemButton) {
		var addSpecifiedRiskItemButtonDefaultDisplay = window.getComputedStyle(addSpecifiedRiskItemButton, null).display;
		var specifiedRiskItems = specifiedRiskItemsWrapper.querySelectorAll('.c-form__repeatable-field');
		var specifiedRiskItemTypes = specifiedRiskItemsWrapper.querySelectorAll('input[type="radio"]');

		var typeValueChoices = JSON.parse(specifiedRiskItemsWrapper.dataset.specifiedRiskItemChoices);
		specifiedRiskItemsWrapper.dataset.index = String(specifiedRiskItems.length);

		addSpecifiedRiskItemButton.addEventListener('click', addSpecifiedRiskItem);

		specifiedRiskItems.forEach(function (item) {
			addSpecifiedRiskItemRemoveButton(item);
		});

		specifiedRiskItemTypes.forEach(function (radioButton) {
			addSpecifiedRiskTypeRadioListener(radioButton);
		});

		validateSpecifiedRiskItems();
	}

	var contentsCoverAmountSelect = document.querySelector(
		'#house_details_step_contentsCoverAmount,#policy_details_step_contentsCoverAmount'
	);
	var specifiedRisksContainer = document.querySelector('#js-specified-risks-container');

	if (contentsCoverAmountSelect) {
		contentsCoverAmountSelect.addEventListener('input', toggleSpecifiedRisksContainer);
	}

	function toggleSpecifiedRisksContainer() {
		if (this.value > 0) {
			show(specifiedRisksContainer);

			return;
		}

		hide(specifiedRisksContainer);
		resetSpecifiedRisks();
	}

	function resetSpecifiedRisks() {
		var unspecifiedRisksCoverAmountSelect = document.querySelector(
			'#house_details_step_unspecifiedRisksCoverAmount, #policy_details_step_unspecifiedRisksCoverAmount'
		);
		unspecifiedRisksCoverAmountSelect.value = '';

		specifiedRiskItemsWrapper.querySelectorAll('.c-form__repeatable-field').forEach(function (item) {
			item.parentNode.removeChild(item);
		});
	}

	function addSpecifiedRiskTypeRadioListener(radioButton) {
		radioButton.addEventListener('change', generateSelectedTypeValues);
	}

	function generateSelectedTypeValues() {
		var choices = typeValueChoices[this.value];
		var thisItemWrapper = this.closest('.c-form__repeatable-field');
		var typeValueSelect = thisItemWrapper.querySelector('select');

		typeValueSelect.options.length = 0;
		typeValueSelect.options[typeValueSelect.options.length] = new Option('Please choose an amount');

		specifiedRiskItemTypes.forEach(function (radioButton) {
			radioButton.addEventListener('change', generateSelectedTypeValues);
		});

		for (key in choices) {
			if (choices.hasOwnProperty(key)) {
				typeValueSelect.options[typeValueSelect.options.length] = new Option(key, choices[key]);
			}
		}
	}

	function addSpecifiedRiskItemRemoveButton(specifiedRiskItem) {
		var removeButton = specifiedRiskItemsWrapper.dataset.removeItemButton;
		specifiedRiskItem.insertAdjacentHTML('beforeend', removeButton);

		specifiedRiskItem.querySelector('.js-remove-specified-risk-button').addEventListener('click', function () {
			specifiedRiskItem.parentNode.removeChild(specifiedRiskItem);
			validateSpecifiedRiskItems();
		});
	}

	function addSpecifiedRiskItem() {
		var prototype = specifiedRiskItemsWrapper.dataset.prototype;

		// get the number of currently added specified risk items
		var index = specifiedRiskItemsWrapper.dataset.index;
		var newFields = prototype;

		// Replace '__name__' in the prototype's HTML to
		// instead be a number based on how many items we have
		newFields = newFields.replace(/__name__/g, index);

		// increase the index with one for the next specified risk item
		specifiedRiskItemsWrapper.dataset.index = String(parseInt(index) + 1);
		specifiedRiskItemsWrapper.insertAdjacentHTML('beforeend', newFields);

		// get recently added fields container and add remove button to it
		var lastFields = specifiedRiskItemsWrapper.querySelectorAll('.c-form__repeatable-field:last-child');
		addSpecifiedRiskItemRemoveButton(lastFields[0]);

		// add listeners to all newly created Type field radio buttons
		var specifiedRiskItemTypes = lastFields[0].querySelectorAll('input[type="radio"]');
		specifiedRiskItemTypes.forEach(function (radioButton) {
			addSpecifiedRiskTypeRadioListener(radioButton);
		});

		validateSpecifiedRiskItems();
	}

	function validateSpecifiedRiskItems() {
		var maxSpecifiedRisksAddedMessage = document.querySelector('#js-maximum-risks-added-error-message');

		if (document.querySelectorAll('.c-form__repeatable-field').length >= MAX_SPECIFIED_RISK_ITEMS) {
			hide(addSpecifiedRiskItemButton);
			show(maxSpecifiedRisksAddedMessage);
		} else {
			show(addSpecifiedRiskItemButton, addSpecifiedRiskItemButtonDefaultDisplay);
			hide(maxSpecifiedRisksAddedMessage);
		}
	}

	/**
	 * HOUSE INSURANCE FORM OTHER PROPOSER DETAILS
	 */
	var addOtherProposerButton = document.getElementById('js-add-other-proposer');

	if (addOtherProposerButton) {
		addOtherProposerButton.addEventListener('click', showOtherProposerFields);
		var addOtherProposerButtonDisplay = window.getComputedStyle(addOtherProposerButton, null).display;
		var otherProposerFieldsContainer = document.getElementById('js-other-proposer-fields-container');
	}

	function showOtherProposerFields() {
		hide(this);
		show(otherProposerFieldsContainer);
	}

	var removeOtherProposerButton = document.getElementById('js-remove-other-proposer');

	if (removeOtherProposerButton) {
		removeOtherProposerButton.addEventListener('click', hideOtherProposerFields);
	}

	function hideOtherProposerFields() {
		show(addOtherProposerButton, addOtherProposerButtonDisplay);
		hide(otherProposerFieldsContainer);
		resetOtherProposerFields();
	}

	function resetOtherProposerFields() {
		var otherProposerFields = otherProposerFieldsContainer.querySelectorAll('select, input');

		otherProposerFields.forEach(function (field) {
			field.value = '';
		});
	}

	/**
	 * HOUSE INSURANCE FORM TOGGLE POSTAL ADDRESS FIELDS
	 */

	var isPostalAddressSameCheckbox = document.querySelector('#customer_details_step_isPostalAddressSame');
	var postalAddressContainer = document.querySelector('#js-postal-address-container');

	if (isPostalAddressSameCheckbox) {
		isPostalAddressSameCheckbox.addEventListener('input', togglePostalAddressContainer);
	}

	function togglePostalAddressContainer() {
		if (!this.checked) {
			show(postalAddressContainer);

			return;
		}

		hide(postalAddressContainer);
		resetPostalAddressFields();
	}

	function resetPostalAddressFields() {
		document.querySelector('#customer_details_step_postalAddressCounty').value = '';
		document.querySelector('#customer_details_step_postalAddressArea').value = '';
		document.querySelector('#customer_details_step_postalAddressLine1').value = '';
		document.querySelector('#customer_details_step_postalAddressEircode').value = '';
	}

	/**
	 * LINKS
	 */
	document.querySelectorAll('a').forEach(function(item) {
		if (item.hostname != window.location.hostname) {
			var string = item.rel;
			var substring = "noopener";
			var substringFound = string.includes(substring);

			// if attribute empty or doesn't contain noopener, add noopener (space is important)
			if (item.rel === "" || substringFound === false) {
				item.rel += ' noopener';
			}
		}
	});

	/**
	 * MOBILE MENU OVERLAY
	 */
		// selectors
	var headerOverlayOpenControl = document.getElementById('js-header-mobile-overlay-control-open');

	var headerOverlayCloseControl = document.getElementById('js-header-mobile-overlay-control-close');

	var headerOverlay = document.getElementById('js-header-mobile-overlay');

	var headerOverlayFirstListItemLink = document.querySelector('#js-header-mobile-overlay .c-header__primary-menu-list:first-of-type .c-header__primary-menu-list-item:first-child .c-header__primary-menu-link');

	// open mobile menu overlay
	function openHeaderOverlay() {
		headerOverlayCloseControl.classList.remove('js-header-mobile-overlay-control-hidden');

		headerOverlay.setAttribute('aria-hidden', false);

		headerOverlay.classList.add('js-header-mobile-overlay-open');

		// prevent body from scrolling
		document.body.classList.add('scroll-lock');

		// change focus to first list element link
		headerOverlayFirstListItemLink.focus();

		headerOverlayOpenControl.classList.add('js-header-mobile-overlay-control-hidden');
	}

	headerOverlayOpenControl.addEventListener('click', function(event) {
		event.stopPropagation();
		event.preventDefault();

		openHeaderOverlay();
	});

	// close mobile menu overlay
	function closeHeaderOverlay() {
		// collapse dropdowns on close
		var activeDropdowns = document.querySelectorAll('.js-has-dropdown.js-active');

		for (var i = 0; i < activeDropdowns.length; i++) {
			activeDropdowns[i].classList.remove('js-active')
		}

		// reset aria attributes
		var dropdownToggles = document.querySelectorAll('.js-dropdown-toggle');

		for (var i = 0; i < dropdownToggles.length; i++) {
			dropdownToggles[i].setAttribute('aria-expanded', false);
		}

		var dropdowns = document.querySelectorAll('.js-dropdown');

		for (var i = 0; i < dropdowns.length; i++) {
			dropdowns[i].setAttribute('aria-hidden', true);
		}

		headerOverlayOpenControl.classList.remove('js-header-mobile-overlay-control-hidden');

		headerOverlay.setAttribute('aria-hidden', true);

		headerOverlay.classList.remove('js-header-mobile-overlay-open');

		// release body scrolling lock
		document.body.classList.remove('scroll-lock');

		// change focus back to open menu link
		headerOverlayOpenControl.focus();

		headerOverlayCloseControl.classList.add('js-header-mobile-overlay-control-hidden');
	}

	headerOverlayCloseControl.addEventListener('click', function(event) {
		event.stopPropagation();
		event.preventDefault();

		closeHeaderOverlay();
	});

	/**
	 * DROPDOWN MENU
	 */
	function toggleDropdown(dropdown, open) {
		if (open) {
			dropdown.classList.add('js-active');
			var adown= dropdown.querySelector('.u-icon');
			adown.setAttribute('id','down-arrow');
			var aup= dropdown.querySelector('.u-icon-up');
			aup.setAttribute('id','up-arrow');
		} else {
			dropdown.classList.remove('js-active');
			dropdown.querySelector('.u-icon').removeAttribute('id');
			dropdown.querySelector('.u-icon-up').removeAttribute('id');
		}

		var toggle = dropdown.querySelector('.js-dropdown-toggle');

		toggle.setAttribute('aria-expanded', open ? true : false);

		if (toggle) {
			var dropdown = document.getElementById(toggle.getAttribute('aria-controls'));

			if (dropdown) {
				dropdown.setAttribute('aria-hidden', open ? false : true);
			}
		}
	}

	/**
	 Closes all dropdowns on the page.
	 */
	function closeAllDropdowns() {
		var dropdowns = document.querySelectorAll('.js-has-dropdown');

		for (var i = 0, l = dropdowns.length; i < l; i++) {
			toggleDropdown(dropdowns[i], false);
		}
	}

	/**
	 Attaches click event listener to dropdown toggle.
	 @param {HTMLElement} dropdownToggle Toggle element of dropdownigation.
	 */
	function setupDropdownToggle(dropdownToggle) {
		dropdownToggle.addEventListener('click', function (event) {
			event.preventDefault();
			event.stopPropagation();

			var dropdown = dropdownToggle.parentElement;

			var isActive = dropdown.classList.contains('js-active');

			closeAllDropdowns();
			if (!isActive) {
				toggleDropdown(dropdown, true);
			}
		});
	}

	// Setup all dropdown toggles on the page
	var dropdownToggles = document.querySelectorAll('.js-dropdown-toggle');

	for (var i = 0, l = dropdownToggles.length; i < l; i++) {
		setupDropdownToggle(dropdownToggles[i]);
	}

	// Close all menus if anything else on the page is clicked
	document.addEventListener('click', function (event) {
		var target = event.target;

		if (target.closest) {
			if (!target.closest('.js-dropdown-toggle') && !target.closest('.js-dropdown')) {
				// tablet-landscape
				var breakpoint = 992;

				// prevents accidentally closing on mobile menu while scrolling on phones and tablets
				if (window.matchMedia('(min-width: ' + breakpoint + 'px)').matches) {
					closeAllDropdowns();
				}
			}
		}
	});

	/**
	 * MODAL
	 */
	var modalInertLayers = document.querySelectorAll('body > header, body > main, body > footer');

	var focusedElementBeforeModal;

	// open modal
	document.querySelectorAll('.js-modal-control-open').forEach(function(item) {
		item.addEventListener('click', function(event) {
			event.preventDefault();
			event.stopPropagation();

			// get active element before modal was opened
			focusedElementBeforeModal = document.activeElement;

			closeAllModals();

			// 'hide' inert layers
			for (var i = 0; i < modalInertLayers.length; i++) {
				modalInertLayers[i].setAttribute('aria-hidden', 'true');
			}

			// prevent body from scrolling
			document.body.classList.add('scroll-lock');

			// get target of clicked modal open control element
			var modalTarget = item.getAttribute('data-modal-target-id');

			var modal = document.getElementById(modalTarget);

			// 'show' targeted modal
			modal.setAttribute('aria-hidden', 'false');

			modal.classList.add('js-modal-open');

			// keep focus in modal
			// Listen for and trap the keyboard
			modal.addEventListener('keydown', trapTabKey);

			// Find all focusable children
			var focusableElementsString = 'a[href], area[href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), button:not([disabled]), iframe, object, embed, [tabindex="0"], [contenteditable]';

			var focusableElements = modal.querySelectorAll(focusableElementsString);

			// Convert NodeList to Array
			focusableElements = Array.prototype.slice.call(focusableElements);

			var firstTabStop = focusableElements[0];

			var lastTabStop = focusableElements[focusableElements.length - 1];

			// Focus on modal first tabindex
			document.querySelector('.js-modal-open [tabindex="0"]').focus();

			function trapTabKey(e) {
				// Check for TAB key press
				if (e.keyCode === 9) {

					// shift + tab, move backwards
					if (e.shiftKey) {
						if (document.activeElement === firstTabStop) {
							e.preventDefault();
							e.stopPropagation();

							lastTabStop.focus();
						}

						// tab, move forward
					} else {
						if (document.activeElement === lastTabStop) {
							e.preventDefault();
							e.stopPropagation();

							firstTabStop.focus();
						}
					}
				}
			}
		});
	});

	// close modal
	document.querySelectorAll('.js-modal-control-close').forEach(function(item) {
		item.addEventListener('click', function(event) {
			event.preventDefault();
			event.stopPropagation();

			closeAllModals();

			resetAllModals();
		});
	});

	document.onkeydown = function(event) {
		var modals = document.getElementsByClassName('js-modal');

		for (var i = 0; i < modals.length; i++) {
			if (modals[i].classList.contains('js-modal-open')) {
				event = event || window.event;

				var isEscape = false;

				if ("key" in event) {
					isEscape = (event.key === "Escape" || event.key === "Esc");
				} else {
					isEscape = (event.keyCode === 27);
				}

				if (isEscape) {
					closeAllModals();

					resetAllModals();
				}
			}
		}
	}

	function closeAllModals() {
		var modals = document.getElementsByClassName('js-modal');

		for (var i = 0; i < modals.length; i++) {
			modals[i].setAttribute('aria-hidden', 'true');

			modals[i].classList.remove('js-modal-open');
		}

		// 'show' inert layer
		for (var i = 0; i < modalInertLayers.length; i++) {
			modalInertLayers[i].setAttribute('aria-hidden', 'false');
		}

		// release body scrolling lock
		document.body.classList.remove('scroll-lock');

		// reset all modal forms
		var modalForms = document.querySelectorAll('.js-modal form');

		for (var i = 0; i < modalForms.length; i++) {
			modalForms[i].reset();
		}

		var buildingsCoverCalculator = document.getElementById('modal-house-insurance-form-buildings-cover-calculator');

		if (typeof(buildingsCoverCalculator) != 'undefined' && buildingsCoverCalculator != null) {
			resetModalBuildingsCoverCalculator();
		}
	}

	function resetAllModals() {
		// reset focus
		focusedElementBeforeModal.focus();
		focusedElementBeforeModal.setAttribute('aria-live', 'polite');

		// clear hash from url
		history.pushState("", document.title, window.location.pathname
			+ window.location.search);
	}

	/**
	 * TESTIMONIALS CAROUSEL
	 */
	var swiperTestimonials = document.getElementById('swiper-testimonials');

	if (swiperTestimonials) {
		var swiper = new Swiper(swiperTestimonials, {
			init: false,
			loop: true,

			effect: 'fade',
			fadeEffect: {
				crossFade: true
			},

			pagination: {
				el: '#swiper-pagination-testimonials',
				clickable: true,
				clickableClass: 'swiper-pagination-clickable'
			}
		});

		var swiperSlides = document.querySelectorAll('#swiper-testimonials .swiper-slide');

		if (swiperSlides.length > 1) {
			swiper.init();
		}
	}

	/**
	 * HERO CAROUSEL
	 */
	var swiperHero = document.getElementById('swiper-hero');

	if (swiperHero) {
		var swiper = new Swiper(swiperHero, {
			init: false,
			loop: true,

			effect: 'fade',
			fadeEffect: {
				crossFade: true
			},

			pagination: {
				el: '#swiper-pagination-hero',
				clickable: true,
				clickableClass: 'swiper-pagination-clickable'
			}
		});

		var swiperSlides = document.querySelectorAll('#swiper-hero .swiper-slide');

		if (swiperSlides.length > 1) {
			swiper.init();
		}
	}

	/**
	 * PARTNER MOTOR INSURANCE LOGOS CAROUSEL
	 */
	var swiperLogos = document.getElementById('swiper-partner-logos');

	if (swiperLogos) {
		var swiper = new Swiper(swiperLogos, {
			init: false,
			loop: true,
			slidesPerView: 3,

			breakpoints: {
				// when window width is >= 576px
				576: {
					slidesPerView: 6
				}
			},

			pagination: {
				el: '#swiper-pagination-partner-logos',
				clickable: true,
				clickableClass: 'swiper-pagination-clickable'
			}
		});

		var swiperSlides = document.querySelectorAll('#swiper-partner-logos .swiper-slide');

		if (swiperSlides.length > 1) {
			swiper.init();
		}
	}

	/**
	 * PARTNER LIFE ASSURANCE LOGOS CAROUSEL
	 */
	var swiperLogosLife = document.getElementById('swiper-partner-logos-life');

	if (swiperLogosLife) {
		var swiperLife = new Swiper(swiperLogosLife, {
			init: false,
			loop: true,
			slidesPerView: 3,

			breakpoints: {
				// when window width is >= 576px
				576: {
					slidesPerView: 3
				}
			},

			pagination: {
				el: '#swiper-pagination-partner-logos-life',
				clickable: true,
				clickableClass: 'swiper-pagination-clickable-life'
			}
		});

		var swiperSlidesLife = document.querySelectorAll('#swiper-partner-logos-life .swiper-slide');

		if (swiperSlidesLife.length > 1) {
			swiperLife.init();
		}
	}

	/**
	 * ACCORDION
	 */
	var accordion = document.getElementsByClassName("js-accordion");

	// only run code if form exists on page
	if (typeof(accordion) != 'undefined' && accordion != null) {
		document.querySelectorAll('.js-accordion-trigger').forEach(function(item) {
			item.addEventListener('click', function(event) {
				event.preventDefault();

				if (this.getAttribute('aria-expanded') === 'false') {
					// open if closed
					this.setAttribute('aria-expanded', true);

					this.nextElementSibling.setAttribute('aria-hidden', false);
				} else {
					// close if open
					this.setAttribute('aria-expanded', false);

					this.nextElementSibling.setAttribute('aria-hidden', true);
				}
			});
		})
	}

	/**
	 * IFRAME WRAPPER
	 * wrap all selectors to allow CSS to maintain aspect ratio
	 */

	var richTextWrapperIframe = document.querySelectorAll('.js-content iframe');
	var skipWrappingClass = 'skip-wrapping';

	if (richTextWrapperIframe.length > 0) {
		richTextWrapperIframe.forEach(function (item) {
			if (item.classList.contains(skipWrappingClass) || item.parentElement.classList.contains(skipWrappingClass)) {
				return;
			}

			// create new element with class
			var wrapper = document.createElement('span');
			wrapper.classList.add('u-iframe-wrapper');

			// insert wrapper before item in the DOM tree
			item.parentNode.insertBefore(wrapper, item);

			// move item into wrapper
			wrapper.appendChild(item);

			var prevSibling = wrapper.previousElementSibling;

			if (typeof (prevSibling) != 'undefined' && prevSibling != null && prevSibling.classList.contains('c-loader')) {
				prevSibling.style.display = 'none';
			}

			item.addEventListener('load', function () {
				if (item.style.visibility === 'hidden') {
					item.style.visibility = 'visible';
				}
			});
		});
	}

	/**
	 * DISCOUNT CODE
	 */
	var discountCodeButton = document.getElementById('discount-code-button');

	if (discountCodeButton) {
		discountCodeButton.addEventListener('click', function(event) {
			event.preventDefault();

			var discountCodeInput = document.getElementById('payment_method_step_discountCode');
			var flowInstanceId = document.getElementById('payment_method_step_flow_getHouseInsuranceQuote_instance').value;

			var discountCodeErrorText = document.getElementById('discount-code-error-text');
			discountCodeErrorText.textContent = '';

			handleAjaxRequest(
				discountCodeInput.dataset.discountUrl + '?discountCode=' + discountCodeInput.value + '&flowInstanceId=' + flowInstanceId,
				'GET',
				function (data) {
					if (data.error !== undefined) {
						discountCodeErrorText.textContent = data.error;
					} else {
						location.reload();
					}
				});
		});
	}

	/**
	 * DATALAYERS
	 */

	var houseInsuranceHouseDetailsStep = document.querySelector('#house-insurance-house-details-step');
	if (houseInsuranceHouseDetailsStep) {
		houseInsuranceHouseDetailsStep.addEventListener('submit', function(event) {

			var day = document.getElementById('house_details_step_dateOfBirthDay').value;
			var month = document.getElementById('house_details_step_dateOfBirthMonth').value;
			var year = document.getElementById('house_details_step_dateOfBirthYear').value;
			var quoteId = document.getElementById('house_details_step_flow_getHouseInsuranceQuote_instance').value;

			var age = getAgeFromDOB(year + '/' + month + '/' + day);

			sessionStorage.setItem('age', age);
			sessionStorage.setItem('quoteId', quoteId);
		});
	}

	var houseInsuranceDeclarationsStep = document.querySelector('#house-insurance-declarations-step');
	if(houseInsuranceDeclarationsStep) {
		dataLayer(
			'Step 1 - submit',
			'Success',
			'',
			'Home',
			sessionStorage.getItem('age'),
			sessionStorage.getItem('quoteId')
		)
	}

	var houseInsuranceQuoteStep = document.querySelector('#house-insurance-quote-step');
	if(houseInsuranceQuoteStep) {
		dataLayer(
			'Step 2 - submit',
			'Success',
			'',
			'Home',
			sessionStorage.getItem('age'),
			sessionStorage.getItem('quoteId')
		)
	}

	var houseInsuranceCustomerDetailsStep = document.querySelector('#house-insurance-customer-details-step');
	if(houseInsuranceCustomerDetailsStep) {
		dataLayer(
			'Step 3 - submit',
			'Success - ' + sessionStorage.getItem('selectedPremium'),
			sessionStorage.getItem('eventValue'),
			'Home',
			sessionStorage.getItem('age'),
			sessionStorage.getItem('quoteId')
		)
	}

	var houseInsurancePaymentMethodStep = document.querySelector('#house-insurance-payment-method-step');
	if(houseInsurancePaymentMethodStep) {
		dataLayer(
			'Step 4 - submit',
			'Success',
			'',
			'Home',
			sessionStorage.getItem('age'),
			sessionStorage.getItem('quoteId')
		)
	}

	var houseInsurancePaymentStep = document.querySelector('#house-insurance-payment-step');
	if(houseInsurancePaymentStep) {
		sessionStorage.setItem('payableAmount', document.getElementById('payable-amount').innerText);
		dataLayer(
			'Step 5 - submit',
			'Success',
			'',
			'Home',
			sessionStorage.getItem('age'),
			sessionStorage.getItem('quoteId')
		)
	}

	var houseInsuranceQuoteSuccess = document.querySelector('#house-insurance-quote-success');
	if(houseInsuranceQuoteSuccess) {
		dataLayer(
			'Step 6 - submit',
			'Success - ' + sessionStorage.getItem('selectedPremium'),
			sessionStorage.getItem('payableAmount'),
			'Home',
			sessionStorage.getItem('age'),
			sessionStorage.getItem('quoteId')
		)
	}

	var houseInsuranceQuoteDeclined = document.querySelector('#house-insurance-quote-decline');
	if(houseInsuranceQuoteDeclined) {
		dataLayer(
			'Step 1/2 - submit',
			'Decline',
			'',
			'Home',
			sessionStorage.getItem('age'),
			sessionStorage.getItem('quoteId')
		)
	}

	var convictedDriverCarInsurance = document.querySelector('#convicted-driver-insurance-form');
	if (convictedDriverCarInsurance) {
		convictedDriverCarInsurance.addEventListener('submit', function(event) {
			var day = document.getElementById('convicted_driver_insurance_quote_dateOfBirthDay').value;
			var month = document.getElementById('convicted_driver_insurance_quote_dateOfBirthMonth').value;
			var year = document.getElementById('convicted_driver_insurance_quote_dateOfBirthYear').value;
			var age = getAgeFromDOB(year + '/' + month + '/' + day);
			var quoteId = document.getElementById('convicted_driver_insurance_quote_uuid').value;

			dataLayer(
				'Step 1 - submit',
				'Success',
				'',
				'Convicted Drivers',
				age,
				quoteId
			)
		});
	}

	var vanInsurance = document.querySelector('#van-insurance-form');
	if (vanInsurance) {
		vanInsurance.addEventListener('submit', function(event) {
			var day = document.getElementById('van_insurance_quote_dateOfBirthDay').value;
			var month = document.getElementById('van_insurance_quote_dateOfBirthMonth').value;
			var year = document.getElementById('van_insurance_quote_dateOfBirthYear').value;
			var age = getAgeFromDOB(year + '/' + month + '/' + day);
			var quoteId = document.getElementById('van_insurance_quote_uuid').value;

			dataLayer(
				'Step 1 - submit',
				'Success',
				'',
				'Van',
				age,
				quoteId
			)
		});
	}

	/**
	 * Van Insurance Pop up
	 */

	var popup = null;

	function showPopup() {
		if (popup !== null) {
			return;
		}

		popup = document.createElement('div');
		popup.className = 'popup';

		var popupHeading = document.createElement('div');
		popupHeading.className = 'popup-heading';
		popupHeading.textContent = 'Call now and get €40 off';

		var popupText = document.createElement('div');
		popupText.className = 'popup-text';
		popupText.innerHTML = 'Call now and get <bold>€40</bold> off<br><a href="tel:01-4404952">01-4404952</a>';

		var closeButton = document.createElement('span');
		closeButton.className = 'close-button';
		closeButton.textContent = 'x';

		closeButton.addEventListener('click', function() {
			popup.style.opacity = '0';
			setTimeout(function() {
				popup.style.display = 'none';
				popup = null;
			}, 300);
		});

		popup.appendChild(popupHeading);
		popup.appendChild(popupText);
		popup.appendChild(closeButton);

		document.body.appendChild(popup);

		setTimeout(function() {
			popup.style.opacity = '1';
		}, 100);
	}

	document.querySelectorAll('.show-popup').forEach(function(element) {
		element.addEventListener('mouseover', function() {
			showPopup();
		});
	});

	/**
	 * MINIMAL BUILDING COVER AMOUNT SWITCH
	 */

	var buildingCoverAmountSelect = document.querySelector(
		'#house_details_step_buildingCoverAmount, #policy_details_step_buildingCoverAmount'
	);
	buildingCoverAmountSelect.addEventListener('change', forceMinimalBuildingCoverAmount);

	var underInsuranceContainer = document.querySelector('#under-insurance-container');
	var minimalBuildingCover = underInsuranceContainer.dataset.minimalBuildingCover;

	function forceMinimalBuildingCoverAmount() {
		if (this.value < minimalBuildingCover && this.value !== '0' && this.value !== '') {
			this.value = minimalBuildingCover;

			show(underInsuranceContainer);
		} else {
			hide(underInsuranceContainer);
		}
	}
}
